import { Component, OnInit } from '@angular/core';
import { ProfileComponent } from '../../pages/profile/profile.component';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Essentials, MsgType } from '../../util/essentials';
import { Blockade } from '../../model/blockade';
import { DatePipe } from '@angular/common';
import { BlockadePreset } from '../../model/blockade-preset';

@Component({
  selector: 'edit-blockade',
  templateUrl: './edit-blockade.component.html',
  styleUrls: ['./edit-blockade.component.css']
})
export class EditBlockadeComponent implements OnInit {

  constructor(protected dialogRef: NbDialogRef<EditBlockadeComponent>, private datepipe: DatePipe, private translate: TranslateService) {
  }

  private ngOnInitCompleted: boolean = false;
  private blockadeOptions: Blockade[] = [];
  private selectedBlockade: Blockade;
  private scheduledBlockadeEnd: boolean = false;
  private selectedEndDate: Date;
  private selectedEndTime: string;
  private description: string;
  private isUserBlockade = false;
  public isUserBlockadeEdit = false;
  public blockadeEdit: Blockade;
  public blockadePresets: BlockadePreset[] = [];

  ngOnInit(): void {
    this.isUserBlockade = this.isUserBlockadeEdit;
    let loadedBlockade = this.blockadeEdit != null && Blockade.isActive(this.blockadeEdit) ? new Blockade(this.blockadeEdit) : null;
    this.addOption(loadedBlockade);

    this.blockadePresets.forEach(bp => {
      let blockade = new Blockade();
      blockade.name = bp.name;
      let dateNow = new Date(Date.now());
      blockade.startAt = this.datepipe.transform(dateNow, 'yyyy-MM-ddTHH:mm:ss');
      if (bp.periodInDays != undefined && bp.periodInDays > 0) {
        let dateEnd = dateNow.setDate(dateNow.getDate() + bp.periodInDays);
        blockade.endAt = this.datepipe.transform(dateEnd, 'yyyy-MM-ddTHH:mm:ss');
      }
      else blockade.endAt = null;
      this.addOption(blockade);
    });

    this.onBlockadeChange(loadedBlockade);
    this.ngOnInitCompleted = true;
  }

  addOption(blockade: Blockade) {
    if (blockade != null && this.blockadeOptions.some(b => b.name == blockade.name) == false) {
      this.blockadeOptions.push(blockade);
    }
  }

  onBlockadeChange(blockade: Blockade) {
    console.log(blockade);
    this.selectedBlockade = blockade;
    if (this.selectedBlockade != null) {
      this.scheduledBlockadeEnd = this.selectedBlockade.endAt != null;
      if (this.scheduledBlockadeEnd) {

        let endAt = new Date(blockade.endAt)
        this.selectedEndDate = endAt;

        let endTime = `${endAt.getHours() >= 10 ? endAt.getHours() : ('0' + endAt.getHours())}`
          + `:${endAt.getMinutes() >= 10 ? endAt.getMinutes() : ('0' + endAt.getMinutes())}`;
        this.selectedEndTime = endTime;
      }
      this.description = this.selectedBlockade.description;
    }

  }

  setDateAndTime(date: Date, timeStr: string) {
    let hours = Number.parseInt(timeStr.split(':')[0]);
    let minutes = Number.parseInt(timeStr.split(':')[1]);
    let dateTime: Date = new Date(date.setHours(hours, minutes, 0, 0));
    return dateTime;
  }

  onConfirm() {
    if (this.selectedBlockade != null) {

      if (this.scheduledBlockadeEnd) {
        let configuredEndAt = this.setDateAndTime(this.selectedEndDate, this.selectedEndTime);
        this.selectedBlockade.endAt = this.datepipe.transform(configuredEndAt, 'yyyy-MM-ddTHH:mm:ss');
      }
      else {
        this.selectedBlockade.endAt = null;
      }

      this.selectedBlockade.description = this.description;
    }

    if (this.isUserBlockadeEdit != this.isUserBlockade) this.selectedBlockade.id = 0;

    this.dialogRef.close({ blockade: this.selectedBlockade, isUserBlockade: this.isUserBlockade });
  }

  close() {
    this.dialogRef.close();
  };

}
